import { createAction } from 'redux-actions'

import {
  GET_PURCHASE_ORDER,
  GET_PURCHASE_ORDER_FAILED,
  GET_PURCHASE_ORDER_SUCCEEDED,
} from 'Redux/Types/PurchaseOrdersTypes'

export const getPurchaseOrder = createAction(GET_PURCHASE_ORDER)
export const getPurchaseOrderFailed = createAction(GET_PURCHASE_ORDER_FAILED)
export const getPurchaseOrderSucceeded = createAction(GET_PURCHASE_ORDER_SUCCEEDED)
